import type { SVGProps } from "react";
import { memo } from "react";
const Braket = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#C8511B" />
        <stop offset="100%" stopColor="#F90" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M35.628 61.366a92 92 0 0 0 2-1.458v5.72h-2zm25.745-25.738h4.255v2h-5.71q.749-1.002 1.455-2m-1.745 6h6v2h-6v4h6v2h-6v4h6v2h-6v3a1 1 0 0 1-1 1h-3v6h-2v-6h-4v6h-2v-6h-4v6h-2v-6h-3.631a103 103 0 0 0 2.55-2h17.08V40.557a101 101 0 0 0 2-2.55zm-40 14h-6v-2h6v-4h-6v-2h6v-4h-6v-2h6v-4h-6v-2h6v-4h-6v-2h6v-4h-6v-2h6v-3a1 1 0 0 1 1-1h3v-6h2v6h4v-6h2v6h4v-6h2v6h4v-6h2v6h4v-6h2v6h4v-6h2v6h3a1 1 0 0 1 1 1v6.647a62 62 0 0 1-2 3.217v-8.864h-36v36h8.865a62 62 0 0 1-3.217 2h-6.648a1 1 0 0 1-1-1zm28-12c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.795-4-4 1.794-4 4-4m0 10c3.309 0 6-2.692 6-6a5.97 5.97 0 0 0-1.4-3.846C66.545 27.97 69.33 17.004 65.79 13.465c-1.501-1.502-3.91-1.847-7.163-1.044v2.073c2.71-.747 4.74-.623 5.749.385 3.692 3.692-4.14 17.042-13.673 27.607a5.95 5.95 0 0 0-3.076-.858c-3.31 0-6 2.69-6 6 0 1.125.317 2.175.858 3.076C31.9 60.25 18.576 68.07 14.879 64.377c-1.007-1.008-1.131-3.04-.385-5.75H12.42c-.803 3.254-.457 5.662 1.044 7.164.899.899 2.275 1.39 4.087 1.39 5.33 0 14.433-4.275 26.227-14.956a5.97 5.97 0 0 0 3.849 1.403"
      />
    </g>
  </svg>
);
const Memo = memo(Braket);
export default Memo;
